import { DashboardFeatureId } from '../../../AdviserArea/AdviserArea.types';
import { LandingPage } from '../../ClientAccess.types';

export const SELECT_WIDTH = 320;

interface GetLandingPageRequiredAccessParams {
  isOrionClient?: boolean;
}

export const getLandingPageRequiredAccess = ({
  isOrionClient,
}: GetLandingPageRequiredAccessParams) => ({
  [LandingPage.Overview]: null,
  [LandingPage.GoalResults]: [DashboardFeatureId.FinancialPlan],
  [LandingPage.PersonalFinances]: [DashboardFeatureId.CurrentFinances],
  [LandingPage.Profile]: [DashboardFeatureId.FinancialPlan, DashboardFeatureId.EditProfile],
  [LandingPage.Reports]: [DashboardFeatureId.FinancialPlan],
  [LandingPage.DocumentVault]: [DashboardFeatureId.DocumentVault],
  [LandingPage.Newsfeed]: null, // OC setting.
  [LandingPage.AssetBucketing]: null,
  [LandingPage.BeFi20]: [DashboardFeatureId.FinancialPlan],
  [LandingPage.PersonalFinancesSummary]: [DashboardFeatureId.CurrentFinances],
  [LandingPage.PersonalFinancesPositions]: [DashboardFeatureId.CurrentFinances],
  [LandingPage.PersonalFinancesNetWorth]: isOrionClient
    ? [DashboardFeatureId.CurrentFinances, DashboardFeatureId.NetWorth]
    : [DashboardFeatureId.CurrentFinances],
  [LandingPage.PulseCheck]: [DashboardFeatureId.FinancialPlan],
});

export const landingPageNameMap = {
  0: 'Client Overview',
  1: 'Goal Results',
  2: 'Personal Finances',
  3: 'Profile',
  4: 'Reports',
  5: 'Document Vault',
  6: 'Credit & Identity Monitoring',
  7: 'NewsFeed',
  8: 'Asset Bucketing',
  9: 'BeFi20',
  10: 'Personal Finances - Summary',
  11: 'Personal Finances - Positions',
  12: 'Personal Finances - Net Worth',
  13: 'PulseCheck',
};

export const MOBILE_LANDING_PAGES = [
  LandingPage.AssetBucketing,
  LandingPage.DocumentVault,
  LandingPage.Newsfeed,
  LandingPage.GoalResults,
  LandingPage.Overview,
  LandingPage.PersonalFinances,
  LandingPage.PersonalFinancesNetWorth,
  LandingPage.PersonalFinancesPositions,
  LandingPage.PersonalFinancesSummary,
  LandingPage.BeFi20,
  LandingPage.Reports,
];
